import React, { MouseEventHandler } from 'react';
import './TherapistAvailabilityWidget.scss';
import slotLoadingImage from '../../../../assets/images/slots.svg';
import daysLoadingImage from '../../../../assets/images/days.svg';
import AppButton from 'src/components/base/Button/Button';
import DropdownContainer from '../DropdownComponent/DropdownContainer';
import TherapistAvailabilitySlotContainer from './TherapistAvailabilitySlotContainer';
import { Spinner } from 'react-bootstrap';
import { AvailabilitySlot, Choices } from '../../types/TherapistAvailabilityWidget';
import { TherapistAvailabilityWidgetEnum } from './TherapistAvailabilityWidgetEnum';
import { Typography } from "src/latest/src/components";


type TherapistAvailabilityWidgetType = {
  clientAgeFilterData: any;
  insuranceFilterData: any;
  serviceTypeFilterData: any;
  setSelectedClientAgeData: (selectedValue: any[]) => void;
  setSelectedInsuranceData: (selectedValue: any[]) => void;
  setSelectedServiceTypeData: (selectedValue: any[]) => void;
  clientAgeMenuData: [Choices];
  insuranceMenuData: [Choices];
  serviceTypeMenuData: [Choices];
  handleAailabilityBtnClick: () => void;
  toggleAvailableBtn: boolean;
  availableSlotData: any;
  therapistSlotData: any;
  formattedTherapistSlotData: any;
  sliderDateChange: (date: string) => void;
  bookAppointmentSlot: (  slotData: { slot: AvailabilitySlot; date: string },
      therapistAvailableData: any,) => void;
  showMoreSlots: boolean;
  handleShowMoreSlots: MouseEventHandler;
  dropDownDisabled: boolean;
  toggleShowMoreSlots: boolean;
  hideTitle?: boolean;
  handleLaterSlot: (slotData: any) => void;
};

const TherapistAvailabilityWidget: React.FC<
  TherapistAvailabilityWidgetType
> = ({
  clientAgeFilterData,
  serviceTypeFilterData,
  insuranceFilterData,
  setSelectedClientAgeData,
  setSelectedInsuranceData,
  setSelectedServiceTypeData,
  clientAgeMenuData,
  serviceTypeMenuData,
  insuranceMenuData,
  handleAailabilityBtnClick,
  toggleAvailableBtn,
  availableSlotData,
  therapistSlotData,
  formattedTherapistSlotData,
  sliderDateChange,
  bookAppointmentSlot,
  showMoreSlots,
  handleShowMoreSlots,
  dropDownDisabled,
  toggleShowMoreSlots,
  hideTitle,
  handleLaterSlot,
}) => {

  const handleClientAgeDropdown = (value: []) => {

    const selectedValue =
      value && value?.length > 0
        ? value?.filter((item: any) => item.selected === true)
        : [];

    setSelectedClientAgeData(selectedValue);
  };

  const handleInsuranceDropdown = (value: []) => {

    const selectedValue =
      value && value?.length > 0
        ? value?.filter((item: any) => item.selected === true)
        : [];

    setSelectedInsuranceData(selectedValue);
  };

  const handleServiceTypeDropdown = (value: []) => {
  
      const selectedValue =
        value && value?.length > 0
          ? value?.filter((item: any) => item.selected === true)
          : [];
  
      setSelectedServiceTypeData(selectedValue);
    };


  return (
    <>
      {availableSlotData ? (
        <div className={`Therapist-availability-widget-container ${showMoreSlots && toggleShowMoreSlots ? 'show_more_height' : ''}`}>
          <TherapistAvailabilitySlotContainer
            availableSlotData={availableSlotData}
            therapistSlotData={therapistSlotData}
            headingTextForAvailabilityWidget={TherapistAvailabilityWidgetEnum?.headingTextForAvailabilityWidget}
            formattedTherapistSlotData={formattedTherapistSlotData}
            sliderDateChange={sliderDateChange}
            bookAppointmentSlot={bookAppointmentSlot}
            showMoreSlots={showMoreSlots}
            handleShowMoreSlots={handleShowMoreSlots}
            dropDownDisabled={dropDownDisabled}
            toggleShowMoreSlots={toggleShowMoreSlots}
            hideTitle={hideTitle}
            handleLaterSlot={handleLaterSlot}
          />
          <div className="Therapist-availability-widget-container-dropdown">
            <div className="Therapist-availability-widget-container-dropdown-div">
              {clientAgeFilterData && clientAgeFilterData?.length > 0 && (
                <div>
                  <DropdownContainer
                    className="widget_container_dropdown"
                    onChangeValue={handleClientAgeDropdown}
                    menu={clientAgeMenuData && clientAgeMenuData}
                    title={
                      clientAgeFilterData &&
                      clientAgeFilterData[0]?.filter_display_title
                        ? clientAgeFilterData[0]?.filter_display_title
                        : TherapistAvailabilityWidgetEnum?.choose_client_age
                    }
                    dropDownDisabled={dropDownDisabled}
                  />
                </div>
              )}
              {insuranceFilterData && insuranceFilterData?.length > 0 && (
                <div>
                  <DropdownContainer
                    className="widget_container_dropdown"
                    onChangeValue={handleInsuranceDropdown}
                    menu={insuranceMenuData}
                    title={
                      insuranceFilterData &&
                      insuranceFilterData[0]?.filter_display_title
                        ? clientAgeFilterData[0]?.filter_display_title
                        : TherapistAvailabilityWidgetEnum?.choose_insurance
                    }
                    dropDownDisabled={dropDownDisabled}
                  />
                </div>
              )}
              {serviceTypeFilterData && serviceTypeFilterData?.length > 0 && (
                <div>
                  <DropdownContainer
                    className="widget_container_dropdown"
                    onChangeValue={handleServiceTypeDropdown}
                    menu={serviceTypeMenuData}
                    title={
                      serviceTypeFilterData &&
                      serviceTypeFilterData[0]?.filter_display_title
                        ? serviceTypeFilterData[0]?.filter_display_title
                        : TherapistAvailabilityWidgetEnum?.choose_servie_type
                    }
                    dropDownDisabled={dropDownDisabled}
                  />
                </div>
              )}
            </div>
            <div>
              <div className="Therapist-availability-widget-container-dropdown-div">
                <div className="Therapist-availability-widget-container-dropdown-div-btn">
                  <AppButton
                    className="Therapist-availability-widget-container-dropdown-div-btn-view"
                    disabled={!toggleAvailableBtn}
                    label={TherapistAvailabilityWidgetEnum?.update_availability}
                    onClick={handleAailabilityBtnClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="Therapist-availability-widget-container">
          {dropDownDisabled ? (
            <div className="Therapist-availability-widget-container-card">
              {!hideTitle && (
                <div className="Therapist-availability-widget-container-div">
                  <Typography className="Therapist-availability-widget-container-head-text">
                    {TherapistAvailabilityWidgetEnum?.headingTextForAvailabilityWidget}
                  </Typography>
                </div>
              )}
              <div className="Therapist-availability-widget-container-div Therapist-availability-widget-container-days-img-div">
                <img
                  src={daysLoadingImage}
                  alt="Available Days"
                  className="blur-days-img"
                />
              </div>
              <div className="Therapist-availability-widget-container-spinner-div">
                <Spinner
                  animation="border"
                  role="status"
                  variant="dark"
                  className="m-auto"
                />
              </div>
            </div>
          ) : (
            <div className="Therapist-availability-widget-container-card">
              {!hideTitle && (
                <div className="Therapist-availability-widget-container-div">
                  <Typography className="Therapist-availability-widget-container-head-text">
                    {TherapistAvailabilityWidgetEnum?.headingTextForAvailabilityWidget}
                  </Typography>
                </div>
              )}
              <div className="Therapist-availability-widget-container-div Therapist-availability-widget-container-days-img-div">
                <img src={daysLoadingImage} alt="Available Days" />
              </div>
              <div className="Therapist-availability-widget-container-div Therapist-availability-widget-container-slot-img-div">
                <img src={slotLoadingImage} alt="Available Slot" />
              </div>
              <div className="Therapist-availability-widget-container-div Therapist-availability-widget-container-ans-text-div">
                <Typography className="Therapist-availability-widget-container-text">
                  Answer the questions below to get accurate results ↓
                </Typography>
              </div>
            </div>
          )}
          <div className="Therapist-availability-widget-container-dropdown">
            <div className="Therapist-availability-widget-container-dropdown-div">
              {clientAgeFilterData && clientAgeFilterData?.length > 0 && (
                <div>
                  <DropdownContainer
                    className="widget_container_dropdown"
                    onChangeValue={handleClientAgeDropdown}
                    menu={clientAgeMenuData && clientAgeMenuData}
                    title={
                      clientAgeFilterData &&
                      clientAgeFilterData[0]?.filter_display_title
                        ? clientAgeFilterData[0]?.filter_display_title
                        : TherapistAvailabilityWidgetEnum?.choose_client_age
                    }
                    dropDownDisabled={dropDownDisabled}
                  />
                </div>
              )}
              {insuranceFilterData && insuranceFilterData?.length > 0 && (
                <div>
                  <DropdownContainer
                    className="widget_container_dropdown"
                    onChangeValue={handleInsuranceDropdown}
                    menu={insuranceMenuData}
                    title={
                      insuranceFilterData &&
                      insuranceFilterData[0]?.filter_display_title
                        ? clientAgeFilterData[0]?.filter_display_title
                        : TherapistAvailabilityWidgetEnum?.choose_insurance
                    }
                    dropDownDisabled={dropDownDisabled}
                  />
                </div>
              )}
              {serviceTypeFilterData && serviceTypeFilterData?.length > 0 && (
                <div>
                  <DropdownContainer
                    className="widget_container_dropdown"
                    onChangeValue={handleServiceTypeDropdown}
                    menu={serviceTypeMenuData}
                    title={
                      serviceTypeFilterData &&
                      serviceTypeFilterData[0]?.filter_display_title
                        ? serviceTypeFilterData[0]?.filter_display_title
                        : TherapistAvailabilityWidgetEnum?.choose_servie_type
                    }
                    dropDownDisabled={dropDownDisabled}
                  />
                </div>
              )}
            </div>
            <div>
              <div className="Therapist-availability-widget-container-dropdown-div">
                <div className="Therapist-availability-widget-container-dropdown-div-btn">
                  <AppButton
                    className="Therapist-availability-widget-container-dropdown-div-btn-view"
                    disabled={!toggleAvailableBtn}
                    label={TherapistAvailabilityWidgetEnum?.view_availability}
                    onClick={handleAailabilityBtnClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TherapistAvailabilityWidget;
